import { createFileRoute } from '@tanstack/react-router'

import DetailSubmissionPage from '@/components/pages/backoffice/_verification-data/_$verificationId/container/DetailSubmissionPage'

export const Route = createFileRoute(
  '/_backoffice/verification-data/$verificationId/'
)({
  component: DetailSubmissionPage
})
